import { iMessage } from 'domain/interfaces/models/Message';
import { MessageTypes } from 'domain/interfaces/redux/message/types';
import { MessageActions } from './actions';

export const initialState: iMessage = {
  active: 'none',
  actionOk: () => '',
  actionCancel: () => '',
  data: {},
};

const reducer = (state = initialState, action: MessageActions): iMessage => {
  switch (action.type) {
    case MessageTypes.MESSAGE_ACTIVE: {
      const { active } = action.payload;
      const data = active === 'none' ? {} : action.payload.data;
      return { ...state, ...action.payload, data };
    }
    case MessageTypes.SET_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
